(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ts-trade-in-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getControls(field) {
      return Array.prototype.slice.call(field.querySelectorAll('input, select, textarea'));
    }

    function clearControl(control) {
      if (control.type === 'checkbox' || control.type === 'radio') {
        control.checked = false;
        return;
      }
      if (control.tagName === 'SELECT') {
        control.selectedIndex = 0;
        return;
      }
      control.value = '';
    }

    function updateSummary(form) {
      var summary = form.querySelector('[data-ts-summary]');
      if (!summary) return;

      var lines = [];
      Array.prototype.slice.call(form.querySelectorAll('input, select, textarea')).forEach(function (control) {
        if (!control.name || control.disabled || control.hidden || control === summary) return;
        if (control.type === 'hidden') return;
        var field = control.closest('.ts-trade-field');
        if (field && field.hidden) return;
        var label = field ? field.querySelector('label') : null;
        var labelText = label ? label.textContent.replace('*', '').trim() : control.name.replace('contact[', '').replace(']', '');
        var value = control.value ? control.value.trim() : '';
        if (value) lines.push(labelText + ': ' + value);
      });

      summary.value = lines.join('\n');
    }

    function saveForm(form) {
      try {
        var data = {};
        Array.prototype.slice.call(form.elements).forEach(function (control) {
          if (!control.name || control.type === 'hidden' || control.disabled) return;
          data[control.name] = control.value;
        });
        window.localStorage.setItem('techswap_trade_form', JSON.stringify(data));
      } catch (error) {}
    }

    function restoreForm(form) {
      try {
        if (form.querySelector('[data-ts-success]')) {
          window.localStorage.removeItem('techswap_trade_form');
          return;
        }
        var raw = window.localStorage.getItem('techswap_trade_form');
        if (!raw) return;
        var data = JSON.parse(raw);
        Object.keys(data).forEach(function (name) {
          var control = form.querySelector('[name="' + window.CSS.escape(name) + '"]');
          if (control && !control.value) control.value = data[name];
        });
      } catch (error) {}
    }

    function applyDeviceFields(root) {
      var select = root.querySelector('[data-ts-device-select]');
      if (!select) return;

      var activeDevice = select.value;
      Array.prototype.slice.call(root.querySelectorAll('[data-ts-device-field]')).forEach(function (field) {
        var devices = (field.getAttribute('data-devices') || '').split(',');
        var shouldShow = activeDevice && devices.indexOf(activeDevice) !== -1;
        field.hidden = !shouldShow;
        getControls(field).forEach(function (control) {
          control.disabled = !shouldShow;
          control.required = shouldShow && control.hasAttribute('data-required-visible');
          if (!shouldShow) clearControl(control);
        });
      });
    }

    function initTradeForm(root) {
      var form = root.querySelector('.ts-trade-form');
      var select = root.querySelector('[data-ts-device-select]');
      var button = root.querySelector('[data-ts-submit]');
      var submittedAt = root.querySelector('[data-ts-submitted-at]');
      var clientError = root.querySelector('[data-ts-client-error]');
      if (!form || !select || !button) return;

      restoreForm(form);
      applyDeviceFields(root);

      select.addEventListener('change', function () {
        applyDeviceFields(root);
        saveForm(form);
      });

      form.addEventListener('input', function () {
        saveForm(form);
      });

      form.addEventListener('submit', function (event) {
        applyDeviceFields(root);
        if (clientError) clientError.hidden = true;

        if (!form.checkValidity()) {
          event.preventDefault();
          if (clientError) clientError.hidden = false;
          form.reportValidity();
          return;
        }

        if (form.getAttribute('data-submitting') === 'true') {
          event.preventDefault();
          return;
        }

        if (submittedAt) {
          submittedAt.value = new Date().toISOString();
        }

        updateSummary(form);
        saveForm(form);
        form.setAttribute('data-submitting', 'true');
        button.disabled = true;
        button.textContent = button.getAttribute('data-submitting-label') || button.textContent;
      });
    }

    document.querySelectorAll('[data-ts-trade-root]').forEach(initTradeForm);
  })();

  } catch(e) { console.error(e); }
})();
})();
